import { ActionStatus, FACTION_NAMES, Room } from '../../../Constants';
import {
    availableAmenities,
    availableBeds,
    consumeBedTileOptimistically,
    debrisInStorage,
    firstAmenityBedInStorage, firstUpgradedAmenityInStorage,
    firstUpgradedBedInStorage,
    howManyAmenitiesDoIHave,
    howManyFactionBedsDoIHave,
    howManyUpgradedAmenitiesDoIHave,
    howManyUpgradedBedsDoIHave,
    maxTradelaneAmenity,
    maxTradelaneFaction,
    unUpgradedAmenitiesAndBedsInStorage,
    unUpgradedCoreRoomInStorage
} from '../../Game/GamePlayerInfo';


function upgrade(gamePlayerController, aiPackage, storageIndex) {
    if (aiPackage.execute && storageIndex !== null) {
        gamePlayerController.gamePlayerApi.researchUpgrade(storageIndex);
    } else if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickNext();
    }
}


function sell(gamePlayerController, aiPackage, storageIndex) {
    if (aiPackage.execute && storageIndex !== null) {
        gamePlayerController.gamePlayerApi.researchSell(storageIndex);
    } else if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickNext();
    }
}

function buy(gamePlayerController, aiPackage, roomId) {
    if (aiPackage.execute && roomId !== null && roomId !== undefined) {
        gamePlayerController.gamePlayerApi.researchBuyByRoomId(roomId);
        // Optimistically deplete the stale frontend bed pool so a follow-up
        // Research this round doesn't re-pick a faction bed the engine has
        // already handed out. No-op for amenity room ids. See
        // consumeBedTileOptimistically.
        consumeBedTileOptimistically(gamePlayerController.gameData, roomId);
    } else if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickNext();
    }
}



function coreRooms(gamePlayerController, aiPackage) {
    let question = 'Is there an upgraded Core Room in storage?';
    let result = false;
    let reasoning = 'Get core rooms upgraded as soon as possible.';
    let storageIndex = unUpgradedCoreRoomInStorage(gamePlayerController.gamePlayerData);
    if (storageIndex != null) {
        const roomId = gamePlayerController.gamePlayerData.storage[storageIndex];
        if (roomId) {
            result = true;
            aiPackage.addToMessage(`Upgrade ${Room.NAMES[roomId]}`);
            aiPackage.success = true;
        }
    }
    aiPackage.addProvenance(question, result, reasoning);
    return storageIndex;
}


function debris(gamePlayerController, aiPackage) {
    const question = 'Is there debris?'
    const storageIndex = debrisInStorage(gamePlayerController.gamePlayerData);
    let result = false;
    const reasoning = 'Uninstalled Debris is worth Snohe if Sold.'
    if (storageIndex != null) {
        result = true;
        aiPackage.addToMessage(`Sell Debris`);
        aiPackage.success = true;
    }
    aiPackage.addProvenance(question, result, reasoning);
    return storageIndex;
}


function sellOverflowBeds(gamePlayerController, aiPackage) {
    const question = 'Is there overflow of beds?'
    const count = howManyUpgradedBedsDoIHave(
        gamePlayerController.gamePlayerData);
    let result = false;
    let storageIndex = null;
    const reasoning = `Surplus of upgraded Beds (${count}) > 2 = Sell.`
    if (count > 2) {
        result = true;
        storageIndex = firstUpgradedBedInStorage(gamePlayerController.gamePlayerData);
        const roomId = gamePlayerController.gamePlayerData.storage[storageIndex];
        aiPackage.addToMessage(`Sell ${Room.NAMES[roomId]}`);
        aiPackage.success = true;
    }
    aiPackage.addProvenance(question, result, reasoning);

    return storageIndex;
}

function sellOverflowAmenities(gamePlayerController, aiPackage) {
    const question = 'Is there overflow of beds?'
    const count = howManyUpgradedAmenitiesDoIHave(
        gamePlayerController.gamePlayerData);
    let result = false;
    let storageIndex = null;
    const reasoning = `Surplus of upgraded Amenities (${count}) > 2 = Sell.`
    if (count > 2) {
        result = true;
        storageIndex = firstUpgradedAmenityInStorage(gamePlayerController.gamePlayerData);
        const roomId = gamePlayerController.gamePlayerData.storage[storageIndex];
        aiPackage.addToMessage(`Sell ${Room.NAMES[roomId]}`);
        aiPackage.success = true;
    }
    aiPackage.addProvenance(question, result, reasoning);

    return storageIndex;
}


function unupgradedExtras(gamePlayerController, aiPackage) {
    const question = 'Is there a room to upgrade?'
    const storageIndex = unUpgradedAmenitiesAndBedsInStorage(gamePlayerController.gamePlayerData);
    let result = false;
    const reasoning = 'Upgraded rooms take less staff, and are worth more.'
    if (storageIndex != null) {
        result = true;
        const roomId = gamePlayerController.gamePlayerData.storage[storageIndex];
        aiPackage.addToMessage(`Upgrade ${Room.NAMES[roomId]}`);
        aiPackage.success = true;
    }
    aiPackage.addProvenance(question, result, reasoning);
    return storageIndex;
}


function buySomething(gamePlayerController, aiPackage) {
    // if N beds, buy amenity, if n amenity,
    let message = 'Buy ';

    const bedCount = howManyFactionBedsDoIHave(gamePlayerController.gamePlayerData);
    const amenityCount = howManyAmenitiesDoIHave(gamePlayerController.gamePlayerData);


    let question = `Buy Bed or Amenity?`;
    let bedOrAmenity = bedCount <= amenityCount;
    let answer = bedOrAmenity ? 'Bed' : 'Amenity'
    let reason = `I want a balance of Room types (${bedCount} <= ${amenityCount}).`
    aiPackage.addProvenance(question, answer, reason);

    let roomId;
    if (bedOrAmenity) {
        const factionId = maxTradelaneFaction(gamePlayerController.gameData);
        const factionIndex = factionId - 1;
        question = `Of the first 4 tradelane columns, which Faction is most represented? `;
        answer = FACTION_NAMES[factionIndex];
        reason = 'Beds are faction centered.'
        aiPackage.addProvenance(question, answer, reason);

        let bedRoomId = Room.UNUPGRADED_FACTION_BED_IDS[factionIndex];
        const available = availableBeds(gamePlayerController.gameData);

        question = `Is ${Room.NAMES[bedRoomId]} available?`;
        const bedIsAvailable = available.includes(bedRoomId);
        reason = 'Need an available Bed.'
        aiPackage.addProvenance(question, bedIsAvailable, reason);

        if (bedIsAvailable) {
            roomId = bedRoomId;
        } else {
            // The preferred faction bed is gone from the pool. Fall back to
            // the first actually-available bed (mirror of the amenity
            // branch). Re-picking bedRoomId here committed an unavailable
            // bed, which the engine rejects with "Missing empty location
            // for bed."
            question = `Since ${Room.NAMES[bedRoomId]} is not available, `
                + `what is the first Available Bed?`;
            roomId = available.pop();
            answer = roomId ? Room.NAMES[roomId] : 'None Available';
            reason = 'The next available Bed.'
            aiPackage.addProvenance(question, answer, reason);
        }
    } else {
        const available = availableAmenities(gamePlayerController.gameData);
        const amenityId = maxTradelaneAmenity(gamePlayerController.gameData);
        question = `Of the first 4 tradelane columns, which Amenity is most represented? `;
        answer = Room.NAMES[amenityId];
        reason = 'I want an amenity I can use right away.'
        aiPackage.addProvenance(question, answer, reason);
        question = `Is ${Room.NAMES[amenityId]} available?`;
        let amenityIsAvailable = available.includes(amenityId);
        reason = 'Need an available Amenity.'
        aiPackage.addProvenance(question, amenityIsAvailable, reason);

        if (amenityIsAvailable) {
            roomId = amenityId;
        } else {
            question = `Since ${Room.NAMES[amenityId]} is not available, what is the first Available?`;
            roomId = available.pop();
            answer = roomId ? Room.NAMES[roomId] : 'None Available';
            reason = 'The next available Amenity.'
            aiPackage.addProvenance(question, answer, reason);
        }
    }

    if (roomId === null || roomId === undefined) {
        // Neither a Bed nor an Amenity is available to buy. Don't commit a
        // phantom room id (the old code fired researchBuyByRoomId with an
        // unavailable / undefined id). Let aiResearch fall through to the
        // clickNext skip.
        aiPackage.success = false;
        aiPackage.addToMessage('No buyable Room available.');
        return null;
    }

    aiPackage.addToMessage(message + Room.NAMES[roomId]);
    aiPackage.complete = true;
    aiPackage.success = true;
    return roomId;
}




export function aiResearch(gamePlayerController, aiPackage) {

    let result = coreRooms(gamePlayerController, aiPackage);
    if (!aiPackage.success) {
        result = unupgradedExtras(gamePlayerController, aiPackage);
    }
    if (aiPackage.success) {
        upgrade(gamePlayerController, aiPackage, result);
        return;
    }

    result = debris(gamePlayerController, aiPackage);
    if (!aiPackage.success) {
        result = sellOverflowBeds(gamePlayerController, aiPackage)
    }
    if (!aiPackage.success) {
        result = sellOverflowAmenities(gamePlayerController, aiPackage)
    }

    if (aiPackage.success) {
        sell(gamePlayerController, aiPackage, result);
        return;
    }

    result = buySomething(gamePlayerController, aiPackage);
    if (aiPackage.success) {
        buy(gamePlayerController,aiPackage, result);
        return;
    }

    aiPackage.success = false;
    aiPackage.addToMessage(`I don't want to Research`);
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickNext();
    }
}


export default function artificialResearchAction(gamePlayerController, aiPackage) {
    switch (gamePlayerController.gamePlayerData.action_status) {
    case ActionStatus.INIT_ID:
        aiPackage.addToMessage('Research Initializing');
        return aiPackage;
    case ActionStatus.WAIT_ID:
        return aiResearch(gamePlayerController, aiPackage);
    case ActionStatus.DONE_ID:
        aiPackage.addToMessage('Research Done Confirmation');
        return aiPackage;
    default:
        console.error('Research Too Far.', gamePlayerController.gamePlayerData.action_status);
        break;
    }
}
